import axios from "axios";
import errorHandler from "./errorHandler";

import * as ls from 'utils/localStorage';
import { LS_USER } from "constants/key";

const userData = ls.load(LS_USER);

const instanceLogin = axios.create({
  baseURL: `${process.env.REACT_APP_API_HOST}`,
});

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_HOST}`,
  headers: {
    Authorization: `Bearer ${userData?.token}`,
  },
});

const instanceDownloadFile = axios.create({
  baseURL: `${process.env.REACT_APP_API_HOST}`,
  headers: {
    Authorization: `Bearer ${userData?.token}`,
  },
  responseType: "blob",
});

const instanceUploadFile = axios.create({
  baseURL: `${process.env.REACT_APP_API_HOST}`,
  headers: {
    Authorization: `Bearer ${userData?.token}`,
    "Content-Type": "multipart/form-data",
  },
});

instance.interceptors.response.use((response) => response.data, errorHandler);
instanceLogin.interceptors.response.use(
  (response) => response.data,
  errorHandler
);
instanceDownloadFile.interceptors.response.use(
  (response) => response,
  errorHandler
);
instanceUploadFile.interceptors.response.use(
  (response) => response,
  errorHandler
);

export { instance, instanceLogin, instanceDownloadFile, instanceUploadFile };
